import { render } from "./couponInputComponent.vue?vue&type=template&id=045335c9"
import script from "./couponInputComponent.vue?vue&type=script&lang=js"
export * from "./couponInputComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__